module.exports = __webpack_public_path__ + "static/media/29BDOS15.863f0708.jpg";